import React from "react";
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher({ onAfterChange }) {
    const { i18n } = useTranslation();
    const current = i18n.language === "ar" ? "ar" : "en";

    const handleToggle = (lng) => {
        if (lng !== current) {
            i18n.changeLanguage(lng);
            if (typeof onAfterChange === "function") {
                onAfterChange(lng);
            }
        }
    };

    return (
        <div className="lang-switcher-inline" aria-label="Language switcher">
            <button
                type="button"
                className={`lang-segment ${current === "en" ? "active" : ""}`}
                onClick={() => handleToggle("en")}
            >
                EN
            </button>
            <button
                type="button"
                className={`lang-segment ${current === "ar" ? "active" : ""}`}
                onClick={() => handleToggle("ar")}
            >
                AR
            </button>
        </div>
    );
}

